import qwest from 'qwest';

let AnnouncementApi = {
  getAnnouncementDealer() {
    return qwest.get('/AnnoucementDealer/Get').then((xhr, response) => {
      if (response.success) {
        return response.data;
      }
      throw response;
    });
  }
};

export default AnnouncementApi;
